export default {"src":"/_next/static/media/thunder.342a7f97.svg","height":266,"width":266,"blurWidth":0,"blurHeight":0};